import React, { useState, useEffect, useRef } from 'react';
import './MyCard.css';

const MyCard = () => {
  console.log('MyCard component is rendering');
  
  const [openFAQ, setOpenFAQ] = useState(null);
  const [visibleCards, setVisibleCards] = useState(new Set());
  const cardRefs = useRef([]);

 


  const additionalPlans = [
    {
      id: 1,
      title: "Resume consultation w/ Nicole",
      price: "$50",
      description: "A 15 min resume coaching session with our lead executive coach Nicole.",
      features: [
        "15 min session with our resume coach",
        "Application strategy and resume strategy consult",
        "LinkedIn profile review",
        "Resume audit consult"
      ]
    },
    {
      id: 2,
      title: "Advanced – Custom Resumes",
      price: "$100",
      period: "Every week",
      badge: "Best Value",
      description: "Customized resumes for every application.",
      features: [
        "Everything in Starter plan + below",
        "Up to 40 job applications per week",
        "Custom and tailored resume for every job application",
        "Resume review and audit report – 1x",
        "LinkedIn profile review and audit report – 1x",
        "ATS formatting of primary resume",
        "Senior analyst team support in PST hours"
      ],
      highlighted: true
    },
    {
      id: 3,
      title: "Starter",
      price: "$50",
      period: "Every week",
      description: "Basic job application package.",
      features: [
        "Up to 25 job applications per week",
        "Everything in Promo plan + below",
        "Dedicated application analyst on PST hours with 6 hour SLA",
        "$10/wk credits towards Mobius Advanced Resume Customization"
      ]
    },
    {
      id: 4,
      title: "September Promo Plan",
      price: "$35",
      period: "Every week",
      description: "Ideal for trying out the service with a low but targeted application volume.",
      features: [
        "Up to 15 job applications per week",
        "Search and curation across 1M+ jobs, every 48 hours",
        "Job scan across unlimited job titles"
      ]
    },
    {
      id: 5,
      title: "Resume Rebuild & Repositioning",
      price: "$1,000",
      description: "Best for VP to CxO level positioning – Tech and Non Tech. You will be working with our founder and CEO, Ashwin Agrawal directly.",
      features: [
        "3 half-hour coaching sessions with our founder – Ex-Google",
        "Deep consultation on positioning to stand out",
        "Interview coaching as required",
        "Resume reformat – ATS alignment",
        "Customization of resume to a particular industry or job",
        "Application strategy coaching",
        "Resume build portfolio available upon request"
      ]
    },
    {
      id: 6,
      title: "Resume Build (Mid to Senior)",
      price: "$500",
      setupFee: "+$25 Setup fee",
      description: "Best for manager level to director positioning, Tech or Non Tech. You will be working with Nicole Lau – our executive coach.",
      features: [
        "Two 30 min sessions with our resume coach",
        "Resume fit for the ATS & the human eye",
        "LinkedIn Optimization Tips",
        "Interview prep and career story"
      ]
    },
    {

      id: 7,
      title: "Coaching Session with our Founder/CEO",
      price: "$250",
      description: "One 45 minute coaching session on application strategy, interview prep, offer negotiations, or resume.",
      features: [
        "With our Founder and CEO",
        "Resume positioning – how to best amplify your strengths",
        "Offer negotiation – avg. salary data and negotiation strategy",
        "Interview prep – targeted prep for interview success"
      ]
    },
    {
      id: 8,
      title: "Mock Interview / Interview Prep",
      price: "$500",
      description: "Prep for Marketing, Product, Sales, and VP/Director role interviews.",
      features: [
        "Mock interview – At Google, I interviewed and hired 100's",
        "Two 45 minute sessions with Ashwin for targeted sessions",
        "Real time feedback",
        "Framing, confidence, empathy, value communication"
      ]
    },
    {
      id: 9,
      title: "One Time – Applications Add On (50)",
      price: "$80",
      description: "50 additional applications in a one-week period. Valid for 4 weeks.",
      features: [
        "Add more application volume to your plan"
      ]
    }
  ];

  const faqData = [
    {
      id: 1,
      question: "What is Mobius Services? What are your success rates?",
      answer: "Mobius Services is a comprehensive job application and career coaching platform. We have helped thousands of professionals secure interviews and job offers with our personalized approach."
    },
    {
      id: 2,
      question: "How long has Mobius Services been around?",
      answer: "Mobius was established in 2023 and has supported thousands of job seekers. We have applied to over 4 million jobs on behalf of our clients."
    },
    {
      id: 3,
      question: "What makes Mobius Services unique?",
      answer: "Our unique combination of AI-powered job matching, human expertise, and personalized resume customization sets us apart. We provide dedicated analysts and direct access to our founders."
    },
    {
      id: 4,
      question: "Do you have a free trial?",
      answer: "Yes, we offer consultation sessions and trial periods for new clients. Contact us to learn more about our trial options."
    },
    {
      id: 5,
      question: "Can Mobius Services help me if I'm seeking a very senior role?",
      answer: "Absolutely! We specialize in senior-level placements including VP and C-level positions. Our founder has extensive experience at Google and other top companies."
    },
    {
      id: 6,
      question: "I have a diverse background. How can Mobius Services help me focus my resume?",
      answer: "Our expert coaches specialize in helping professionals with diverse backgrounds create focused, compelling narratives that highlight transferable skills and relevant experience."
    },
    {
      id: 7,
      question: "Does Mobius Services help with ATS optimization?",
      answer: "Yes, all our resume services include ATS optimization to ensure your resume passes through applicant tracking systems and reaches human recruiters."
    },
    {
      id: 8,
      question: "What is the job application service, and how does it work?",
      answer: "Our job application service includes searching, curating, and applying to relevant positions on your behalf. We handle the entire application process while keeping you informed."
    },
    {
      id: 9,
      question: "Can Mobius Services assist me with networking and reaching out to hiring managers?",
      answer: "Yes, we provide networking strategies and can help you craft effective outreach messages to hiring managers and industry professionals."
    },
    {
      id: 10,
      question: "How are Mobius Services priced?",
      answer: "We offer various pricing tiers to fit different needs and budgets, from individual consultations to comprehensive weekly application services."
    },
    {
      id: 11,
      question: "What if I need to pause or adjust my service plan?",
      answer: "We offer flexible service plans that can be paused or adjusted based on your needs. Contact our support team to discuss modifications."
    },
    {
      id: 12,
      question: "Is there any advice for someone considering a career transition during a down market?",
      answer: "Yes, we specialize in career transitions and can help you navigate challenging market conditions with strategic positioning and targeted applications."
    },
    {
      id: 13,
      question: "Does Mobius make any guarantees of interviews or jobs?",
      answer: "While we cannot guarantee specific outcomes, we have a strong track record of success and work diligently to maximize your opportunities."
    },
    {
      id: 14,
      question: "What are plan application limits? What does upto X jobs mean?",
      answer: "Our plans include application limits based on quality over quantity. 'Up to X jobs' means we'll apply to the most relevant positions within that limit each week."
    }
  ];

 
  console.log('Additional plans data:', additionalPlans);

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cardId = parseInt(entry.target.dataset.cardId);
            setVisibleCards(prev => new Set([...prev, cardId]));
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    cardRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      cardRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <div className="mycard-page">
      {/* Header Section */}
      <div className="header-section">
        <h1 className="main-title">Choose a plan that fits your needs</h1>
        <p className="main-subtitle">Not sure which is the right plan for you? Contact us using the whatsapp link below. +1-650-889-6026</p>
      </div>

      
      {/* Additional Plans Section */}
      <section className="additional-plans-section">
        <div className="plans-container">
          <div className="additional-plans-grid">
            {additionalPlans.map((plan, index) => (
              <div 
                key={plan.id} 
                className={`additional-plan-card ${visibleCards.has(plan.id) ? 'visible' : ''}`}
                ref={el => cardRefs.current[index] = el}
                data-card-id={plan.id}
              >
                <div className="additional-plan-header">
                  <h3 className="additional-plan-title">{plan.title}</h3>
                  <div className="additional-plan-price">{plan.price}</div>
                  <p className="additional-plan-description">{plan.description}</p>
                </div>
                <button className="additional-select-btn">Select</button>
                <div className="additional-plan-features">
                  {plan.features.map((feature, index) => (
                    <div key={index} className="additional-feature-item">
                      <span className="additional-checkmark">✓</span>
                      <span className="additional-feature-text">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="disclaimer">
            <p>Mobius Services LLC makes no outcome guarantees</p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="faq-container">
          <div className="faq-content">
            <div className="faq-header">
              <h2 className="faq-title">Frequently Asked Questions</h2>
            </div>
            <div className="faq-list">
              {faqData.map((faq) => (
                <div key={faq.id} className="faq-item">
                  <div 
                    className={`faq-question ${openFAQ === faq.id ? 'active' : ''}`}
                    onClick={() => toggleFAQ(faq.id)}
                  >
                    <span>Q: {faq.question}</span>
                    <span className="faq-icon">{openFAQ === faq.id ? '−' : '+'}</span>
                  </div>
                  {openFAQ === faq.id && (
                    <div className="faq-answer">
                      <p>A: {faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyCard;
